import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import statisticService from "../../services/StatisticService";

export const fetchGeneralStats = createAsyncThunk(
    "statistics/fetchGeneralStats",
    async (filters, thunkAPI) => {
        try {
            const response = await statisticService.getStatistics(filters);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const fetchAnnouncementStats = createAsyncThunk(
    "statistics/fetchAnnouncementStats",
    async (params, thunkAPI) => {
        try {
            const response = await statisticService.getAnnouncementsStats(params);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const fetchDisputeStats = createAsyncThunk(
    "statistics/fetchDisputeStats",
    async (params, thunkAPI) => {
        try {
            const response = await statisticService.getDisputesStats(params);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const fetchReportStats = createAsyncThunk(
    "statistics/fetchReportStats",
    async (params, thunkAPI) => {
        try {
            const response = await statisticService.getReportsStats(params);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

const initialState = {
    generalStats: {
        ownerCount: 0,
        renterCount: 0,
        announcementCount: 0,
        disputeCount: 0,
        reportCount: 0,
        reservationCount: 0,
    },
    announcementStats: [],
    disputeStats: [],
    reportStats: [],
    loading: {
        general: false,
        announcement: false,
        dispute: false,
        report: false,
    },
    error: null,
};

const statisticSlice = createSlice({
    name: "statistics",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // General Stats
            .addCase(fetchGeneralStats.pending, (state) => {
                state.loading.general = true;
            })
            .addCase(fetchGeneralStats.fulfilled, (state, action) => {
                state.loading.general = false;
                state.generalStats = action.payload;
            })
            .addCase(fetchGeneralStats.rejected, (state, action) => {
                state.loading.general = false;
                state.error = action.payload;
            })
            // Announcement Stats
            .addCase(fetchAnnouncementStats.pending, (state) => {
                state.loading.announcement = true;
            })
            .addCase(fetchAnnouncementStats.fulfilled, (state, action) => {
                state.loading.announcement = false;
                state.announcementStats = action.payload;
            })
            // Dispute Stats
            .addCase(fetchDisputeStats.pending, (state) => {
                state.loading.dispute = true;
            })
            .addCase(fetchDisputeStats.fulfilled, (state, action) => {
                state.loading.dispute = false;
                state.disputeStats = action.payload;
            })
            // Report Stats
            .addCase(fetchReportStats.pending, (state) => {
                state.loading.report = true;
            })
            .addCase(fetchReportStats.fulfilled, (state, action) => {
                state.loading.report = false;
                state.reportStats = action.payload;
            });
    },
});

export default statisticSlice.reducer;
